import { getPublicEnvConfig } from "@/config/env";
import { usePathname } from "next/navigation";
import Script from "next/script";
import { useEffect, useState } from "react"

export function AgeGate() {
    const [customerId, setCustomerId] = useState('');
    const pathname = usePathname()
    useEffect(() => {
        if ((window as any)?.init) {
            (window as any).init()
        }
    }, [pathname])
    useEffect(() => {
        setCustomerId(location.hostname.includes('localhost') ? 'whatsyourcocktail.diageoplatform.com' : location.hostname);
    }, [])
    const { AG_USERHASH, BACKEND_HOST: DIAGEO_API_HOST } = getPublicEnvConfig();
    return <>
        {customerId &&
            <Script id="agegate-js"
                src={`${DIAGEO_API_HOST}/file/common/js/diageo-agegate.js`}
                data-customerId={customerId}
                data-userHash={AG_USERHASH}
            />
        }
        <div id="ageGateWrapper"></div>
    </>
}

